import { useState } from "react";
import CopyCode from "../../CopyCode/CopyCode";

const DropdownMenu = () => {
  const [open1, setOpen1] = useState(false);
  const [open2, setOpen2] = useState(false);

  return (
    <div className="flex flex-col gap-y-10 p-6">
      {/* DROPDOWN MENUS */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-white mb-6">Dropdown Menus</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Basic Dropdown</label>
            <div className="p-4 bg-slate-950 rounded border border-slate-600 relative h-24 flex items-center">
              <button onClick={() => setOpen1(!open1)} className="px-3 py-1 bg-slate-700 text-slate-100 rounded text-sm">Actions ?</button>
              {open1 && <div className="absolute top-12 left-4 bg-slate-700 border border-slate-600 rounded shadow-lg z-10">{["Edit", "Copy", "Delete"].map(item => <div key={item} className="px-4 py-2 text-sm text-slate-300 hover:bg-slate-600 cursor-pointer">{item}</div>)}</div>}
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`const [open, setOpen] = useState(false);

return (
  <div className="relative">
    <button onClick={() => setOpen(!open)}>Actions ?</button>
    {open && (
      <div className="absolute bg-slate-700 border border-slate-600 rounded shadow-lg">
        {["Edit", "Copy", "Delete"].map(item => (
          <div key={item} className="px-4 py-2 hover:bg-slate-600">{item}</div>
        ))}
      </div>
    )}
  </div>
);`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Navigation Menu</label>
            <div className="p-2 bg-slate-950 rounded border border-slate-600 h-24">
              <button className="block w-full text-left px-3 py-1 text-sm text-slate-300 hover:bg-slate-800 rounded">File</button>
              <button className="block w-full text-left px-3 py-1 text-sm text-slate-300 hover:bg-slate-800 rounded">Edit</button>
              <button className="block w-full text-left px-3 py-1 text-sm text-slate-300 hover:bg-slate-800 rounded">View</button>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="bg-slate-700 rounded">
  {["File", "Edit", "View"].map(item => (
    <button key={item} className="w-full text-left px-3 py-1 hover:bg-slate-600">
      {item}
    </button>
  ))}
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Icon Menu</label>
            <div className="p-4 bg-slate-950 rounded border border-slate-600 h-24 flex items-center gap-2">
              <button className="w-8 h-8 rounded bg-amber-600 text-white text-xs flex items-center justify-center">?</button>
              <button className="w-8 h-8 rounded bg-amber-600 text-white text-xs flex items-center justify-center">??</button>
              <button className="w-8 h-8 rounded bg-red-600 text-white text-xs flex items-center justify-center">??</button>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="flex gap-2">
  <button className="w-8 h-8 rounded bg-amber-600 text-white">?</button>
  <button className="w-8 h-8 rounded bg-amber-600 text-white">??</button>
  <button className="w-8 h-8 rounded bg-red-600 text-white">??</button>
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Grouped Menu</label>
            <div className="p-2 bg-slate-950 rounded border border-slate-600 h-24 space-y-1">
              <p className="text-xs text-slate-500 px-3 py-1 font-semibold">Items</p>
              <button className="block w-full text-left px-3 py-1 text-xs text-slate-300 hover:bg-slate-800">New Item</button>
              <button className="block w-full text-left px-3 py-1 text-xs text-slate-300 hover:bg-slate-800">Open Item</button>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div><p className="text-slate-500 px-3 py-1">Items</p>
<button className="w-full text-left px-3 py-1">New</button>
<button className="w-full text-left px-3 py-1">Open</button></div>`} />
          </div>
        </div>
      </div>

      {/* ADVANCED OPTIONS */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-amber-400 mb-6">Advanced Options</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Multi-level Menu</label>
            <div className="p-4 bg-slate-950 rounded border border-slate-600 h-24 space-y-1">
              <button className="w-full text-left px-2 py-1 text-xs text-slate-300 hover:bg-slate-800 rounded">File ?</button>
              <div className="pl-4 space-y-1"><button className="w-full text-left text-xs text-slate-400">New</button><button className="w-full text-left text-xs text-slate-400">Open</button></div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<button className="flex justify-between items-center w-full px-2 py-1">
  File
  <span>?</span>
</button>
<div className="pl-4">
  <button>New</button>
  <button>Open</button>
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Search Menu</label>
            <div className="p-4 bg-slate-950 rounded border border-slate-600 h-24 space-y-2">
              <input type="text" placeholder="Search..." className="w-full px-2 py-1 bg-slate-800 border border-slate-600 rounded text-xs text-slate-300" />
              <div className="space-y-1"><p className="text-xs text-slate-400 px-2">Result 1</p><p className="text-xs text-slate-400 px-2">Result 2</p></div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<input type="text" placeholder="Search..." className="w-full px-2 py-1" />
<div className="mt-2">
  {results.map(r => (
    <p key={r} className="px-2 py-1 text-slate-400">{r}</p>
  ))}
</div>`} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DropdownMenu;


